import { defineStore } from "pinia";
import { approveNativeDeviceSession, getNativeDeviceSession } from "@/services/api/tokenomics";

export const useNativeApprovalStore = defineStore("nativeApproval", {
  state: () => ({
    status: null,
    deviceName: null,
    expiresAt: null,
    approving: false,
    approved: false,
    error: null,
  }),
  actions: {
    async loadSession(code) {
      if (!code) return;
      this.error = null;
      try {
        const data = await getNativeDeviceSession(code);
        this.status = data.status;
        this.deviceName = data.deviceName;
        this.expiresAt = data.expiresAt;
      } catch (err) {
        this.error = err instanceof Error ? err.message : "配对会话无效";
      }
    },
    async approveDevice(code) {
      if (!code) return;
      this.approving = true;
      this.error = null;
      try {
        const data = await approveNativeDeviceSession(code);
        this.approved = true;
        this.status = data.status;
        this.deviceName = data.deviceName;
        this.expiresAt = data.expiresAt;
      } catch (err) {
        this.error = err instanceof Error ? err.message : "批准失败";
      } finally {
        this.approving = false;
      }
    },
  },
});
